import axios from 'axios';
import { Dictionary, ListModel, ListConfigurationModel, ListItemsModel } from '@/types';
import AxiosConfiguration from '@/classes/AxiosConfiguration';

const ListApiUrl = 'list/';

export const ListService = {
  async getListAsync(id: number, searchText: string, getAllItems: boolean, keyFilterValues: Dictionary<any>): Promise<ListModel> {
    const response = await axios.post(ListApiUrl, {
      Id: id,
      SearchText: searchText,
      GetAllItems: getAllItems,
      KeyFilterValues: keyFilterValues
    });
    return response.data;
  },
  async postListAsync(listId: number, listItems: any): Promise<any> {
    const response = await axios.post(ListApiUrl.concat('listItem'), {
      listId,
      listItems
    });
    return response.data;
  },
  async putListAsync(listItemsModel: ListItemsModel): Promise<any> {
    const response = await axios.put(ListApiUrl.concat('listItem'), {
      ...listItemsModel
    });
    return response.data;
  },
  async getWorkflowDataFieldListAsync(jobId: number, dataSourceKey: string, dataFieldKey: string): Promise<any> {
    const response = await AxiosConfiguration.axiosWithoutNotification.get(ListApiUrl.concat('workflowDataFieldList'), {
      params: {
        DataSourceKey: dataSourceKey,
        DataFieldKey: dataFieldKey,
        JobId: jobId
      }
    });
    return response.data;
  },
  async getListsAsync(): Promise<ListConfigurationModel> {
    const response = await axios.get(ListApiUrl);
    return response.data;
  },
  async getCanAddItemToListAsync(listId: number): Promise<boolean> {
    const response = await axios.get(`${ListApiUrl}canAddItemToListAsync`, {
      params: {
        listId
      }
    });
    return response.data;
  }
};
